const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/access-denied.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Access-denied destination for permission-guard redirects.
 *
 * Renders inside the authenticated <Sidebar /> layout (the root route's
 * <AuthenticatedTemplate> wraps everything). The `required` and `from`
 * search params are populated by the permission-guard helpers in
 * `@/lib/auth/permission-guard` — both optional for forward-compatibility.
 */

const searchSchema = z.object({
  required: z.string().optional(),
  from: z.string().optional()
});
export const Route = createFileRoute("/access-denied")({
  validateSearch: searchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});